import { render, staticRenderFns } from "./ProcessView.vue?vue&type=template&id=196dcf90"
import script from "./ProcessView.vue?vue&type=script&lang=js"
export * from "./ProcessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports